/**
 * Convert DeviceOrientation angles to camera pose for rear-camera sky AR.
 * Accounts for screen orientation so pitch/yaw match what the user sees.
 */
export function orientationToPose(
  e: DeviceOrientationEvent & { webkitCompassHeading?: number },
): { azimuth: number; elevation: number; roll: number } {
  const alpha = e.alpha ?? 0;
  const beta = e.beta ?? 90;
  const gamma = e.gamma ?? 0;
  const screenAngle = screen.orientation?.angle ?? (window.orientation as number | undefined) ?? 0;

  let azimuth: number;
  if (e.webkitCompassHeading != null) {
    azimuth = e.webkitCompassHeading;
  } else if (e.alpha != null) {
    azimuth = (360 - alpha + screenAngle) % 360;
  } else {
    azimuth = 0;
  }

  // Pitch: + = above horizon. Rear camera in portrait uses beta; landscape swaps axes.
  let elevation: number;
  if (screenAngle === 90 || screenAngle === -90) {
    elevation = 90 - gamma;
  } else {
    // beta - 90: matches iOS/Android rear-camera sky AR (90 - beta is inverted on mobile).
    elevation = beta - 90;
  }

  return {
    azimuth,
    elevation: Math.max(-90, Math.min(90, elevation)),
    roll: gamma,
  };
}
